<template>
  <div class="qjkz">
    <template>
       <h4 style="color: aliceblue;margin-top: -30px">
         球机控制
       </h4>
     </template>
    <div class="u-myflex">
      <div style="min-height: 8.1rem" class="u-flex-7 u-myflex u-flexwrap video-div">
        <!-- <video-ws-stream
          v-if="camera.streamUrl || tempOpen"
          :data="camera"
        ></video-ws-stream> -->
        <assembly-flv v-if="camera.streamUrl"  :url="camera.streamUrl" style="width: 100%;"></assembly-flv>
        <div
          v-else
          style="height: 100%; width: 100%; padding-top: 3rem"
          class="u-text-center u-tips-color"
        >
          <div>
            <i
              style="font-size: 0.6rem"
              class="el-icon-document-delete u-text-center"
            ></i>
          </div>
          <span class="u-font-weight">无法连接相关设备</span>
        </div>
        <div style="width: 200%;">当前设备:{{devicename || '未命名设备'}}</div>
      </div>
      <div class="video-list u-position-relative u-flex-3">
        <el-table :data="mp4Path" stripe class="">
          <el-table-column label="实时播放">
            <template slot-scope="scope">
              <div class="u-myflex u-j-sb u-a-center">
                <el-tooltip
                  :disabled="scope.row.path.length < 28"
                  :content="scope.row.path"
                  placement="top"
                  effect="light"
                >
                  <a
                    href="javascript:;"
                    @click="getChannelid(scope.row.deviceId, scope.row.value ,scope.row.name)"
                    style="margin-left: 10px"
                    :class="[
                      'u-line-1',
                      scope.row.value == videoBtnId ? 'u-color-primary' : 'u-color-dark',
                    ]"
                    >{{ scope.row.path }}</a
                  >
                </el-tooltip>

                <el-select
                  @change="(index) => changeSelect(scope.row.deviceId, index,scope.row.name)"
                  style="width: 100px"
                  v-model="mp4Path[scope.row.value].videoValue"
                  placeholder="通道选择"
                  :key="selectKey"
                  size="mini"
                  v-if="channelOpen"
                >
                  <el-option
                    v-for="item in scope.row.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="u-position-absolute u-t-20 u-r-0">
          <el-pagination
            @current-change="clickPage"
            layout="total,prev, pager, next"
            :total="total"
            :pager-count="5"
            :page-size="13"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="u-position-absolute u-r-20 u-b-10">
      <camera-controller :data="camera"></camera-controller>
    </div>
  </div>
</template>

<script>
import videoWsStream from "@/components/video-ws-stream.vue";
import cameraController from "@/components/camera-controller.vue";
import config from "@/web.config.js";
import assemblyFlv from "@/components/assembly-flv.vue";

export default {
  components: { videoWsStream, cameraController ,"assembly-flv": assemblyFlv},
  data() {
    return {
      tempOpen: config.tempOpen,
      baseUrl: config.cameraUrl,
      total: 0,
      devicename: "暂无",
      camera: {streamUrl:"",deviceId:"",channelId:""},
      streamRequestSeq: 0,
      deviceList: [],
      OlddeviceId:"",
      OldchannelId:"",
      OldstreamUrl:"",
      channelOpen:false,
      deviceListForm: {
        deviceType: "4",
        pageIndex: 1, //经常改，也不知道用哪个字段
        page: 1, //经常改，也不知道用哪个字段
        pageRow: 13,
        limit: 13,
      },
      label: "",
      selectKey: "s",
      videoValue: "",
      mp4Path: [
        // { path: "东城翠峰路中段公交站", value: 0 },
      ],
      videoBtnId: null, //用来保存展开了按钮的列表项
    };
  },
  methods: {
    clickPage(index) {
      this.deviceListForm.pageIndex = this.deviceListForm.page = index;
      this.getDeviceList();
    },
    getDeviceList() {
      this.mp4Path = [];
      //this.$http.POST_deviceList(this.deviceListForm).then((res) => {
        this.$axios({
        	method: 'get',
        	url: this.baseUrl+'/api/device/query/devices?page='+this.deviceListForm.page+'&count=13',
        	timeout: 30000,
        	}).then(res=>{
        if (res.data) {
          if (!this.total) this.total = res.data.total;
          res.data.list.forEach((element, key) => {
            this.mp4Path.push({
              ...element,
              path: element.name || '未命名设备',
              value: key,
              videoValue: "",
            });

          });
        }
      });
    },
    changeSelect(deviceId, mp4PthIndex,devicename) {
      this.devicename = devicename;
      this.openVideo(deviceId,mp4PthIndex);
    },
    openVideo(deviceId,channelId,requestId) {
      const activeRequestId = requestId === undefined ? this.streamRequestSeq + 1 : requestId;
      this.streamRequestSeq = activeRequestId;
      this.camera.streamUrl = "";
      this.camera.channelId = channelId;
      this.camera.deviceId = deviceId;
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/play/start/'+deviceId+'/'+channelId,
      	//headers:this.headers,
      	timeout: 30000,
      	}).then(res=>{
          if (activeRequestId !== this.streamRequestSeq
              || this.camera.deviceId !== deviceId
              || this.camera.channelId !== channelId) {
            return;
          }
          if(res.code == 0){
          // this.camera.streamUrl = res.data.https_flv;
            this.camera.streamUrl = res.data.https_flv.indexOf('39.184.153.92')!=-1?res.data.https_flv.replace('39.184.153.92','huagongyq.dingpod.cn'):res.data.https_flv;
            // if(this.OldstreamUrl != this.camera.streamUrl && this.OldstreamUrl != ""){
            //   this.closeVideo(this.OlddeviceId,this.OldchannelId);
            //   console.log("关闭视频点播")
            // }
          }
          else{
            this.$message.error(res.msg);
          }
      	})
      },

    closeVideo(OlddeviceId,OldchannelId){
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/play/stop/'+OlddeviceId+'/'+OldchannelId,
      	//headers:this.headers,
      	timeout: 30000,
      	}).then(res=>{
      	})
    },
    getChannelid(deviceId,index,devicename){
      const requestId = this.streamRequestSeq + 1;
      this.streamRequestSeq = requestId;
      this.OlddeviceId = this.camera.deviceId;
      this.OldchannelId = this.camera.channelId;
      this.OldstreamUrl = this.camera.streamUrl;
      this.devicename = devicename;
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/device/query/devices/'+deviceId+'/channels?page=1&count=15',
      	timeout: 30000,
      	}).then(res=>{
          if (requestId !== this.streamRequestSeq) {
            return;
          }
          this.camera.channelId = res.data.list[0].deviceId;
          this.camera.deviceId = deviceId;
          this.openVideo(this.camera.deviceId,this.camera.channelId, requestId)
          let n = [];
          res.data.list.forEach((element, key) => {
            n.push({
              lable: element.channelId,
              value: element.channelId,
            });
          });
          let list = this.mp4Path.map((item, key) => {
            if(key == index)
            item.options = n;
            return item;
          });
          this.$set(this, "mp4Path", list);
      	})
    }
  },
  mounted() {
    this.getDeviceList();
    setTimeout(() => {
      this.getChannelid(this.mp4Path[0].deviceId,this.mp4Path[0].value,this.mp4Path[0].name);
    }, 1000);
  },
};
</script>
<style lang="scss">
.qjkz {
  .el-table,
  .el-table__expanded-cell,
  .el-table tr {
    background: #091f38!important;
  }
  .el-table th {
    background: #115599!important;
  }
  .el-input.el-input--suffix {
    input {
      background-color: rgb(71, 154, 175);
    }
  }
  .el-input.el-input--suffix {
    input {
      background-color: rgb(71, 154, 175);
    }
  }
  .el-pager li:hover {
    color: #0f0;
  }
  .el-table__cell {
    a {
      color: #fff !important;
    }
  }
  .el-pagination {
    button {
      background-color: transparent;
    }
  }
}
</style>
<style lang="scss" scoped>
.test-ellipsis {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
.video-div {
  color: #fff;
  font-size: 0.2rem;
  width: 63.5%;
  > div {
    border: 1px #054b76 solid;
    padding: 5px;
    width: 50%;
    text-align: center;
    .video-title {
      border: none;
      padding: 3px 0 5px;
      font-weight: bold;
    }
  }
}
.video-list {
  width: 36.5%;
  height: 100%;
  overflow: auto;
  background: #115599;
  overflow-y: auto;
  padding: 10px 0;
  display: flex;
  h2 {
    text-align: center;
    color: #fff;
  }
  span {
    color: #fff;
  }
  .list-real {
    flex: 2;
    border-right: 1px solid rgb(158, 158, 158);
  }
  .list-history {
    flex: 1;
    border-left: 1px solid rgb(158, 158, 158);
  }
}
.video-name-list {
  width: 100%;
  color: #fff;
  padding: 0 10px;
  cursor: pointer;
  .list-title {
    width: 100%;
    height: 0.4rem;
    font-size: 0.25rem;
    line-height: 0.4rem;
    display: inline-flex;
  }

  .video-btn {
    display: none;
    padding: 5px;
    .el-button--mini {
      font-size: 14px;
      // width:60%;
    }
    > div {
      flex: 1;
      // text-align: center;
    }
  }
  .video-btn-show {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mngm/qjkz.vue